// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* styles for scrollbars during touch-scroll */

.touchscroll-x, .touchscroll-y {
	display: none; /* overridden below */
	overflow: hidden; /* cut off ends of scrollbar during rubber-banding */
	position: absolute;
	/* establish base style for scrollbar fade-in/out */
	opacity: 0.7;
}
.touchscroll-fadeout .touchscroll-x, .touchscroll-fadeout .touchscroll-y {
	opacity: 0;
	-webkit-transition: opacity 0.3s ease-out 0.1s;
	-moz-transition: opacity 0.3s ease-out 0.1s;
	-o-transition: opacity 0.3s ease-out 0.1s;
	transition: opacity 0.3s ease-out 0.1s;
}

.touchscroll-bar {
	background-color: rgba(88,88,88,0.97);
	border: 1px solid rgba(88,88,88,1);
	border-radius: 3px;
	
	/* the borders aren't anti-aliased on Android, so this smooths it out a bit */
	-webkit-box-shadow: 0 0 1px rgba(88,88,88,0.4);
}

.touchscroll-x {
	left: 1px;
	right: 3px;
	bottom: 1px;
	height: 5px;
}
.touchscroll-y {
	top: 1px;
	bottom: 3px;
	right: 1px;
	width: 5px;
}

.touchscroll-scrollable-x .touchscroll-x, .touchscroll-scrollable-y .touchscroll-y {
	display: block; /* display scrollbar when appropriate */
}

.touchscroll-bar {
	/* Establish transition property and timing function for scrollbars */
	-webkit-transition: transform cubic-bezier(0.33, 0.66, 0.66, 1);
	-moz-transition: transform cubic-bezier(0.33, 0.66, 0.66, 1);
	-o-transition: transform cubic-bezier(0.33, 0.66, 0.66, 1);
	transition: transform cubic-bezier(0.33, 0.66, 0.66, 1);
}

/* indicator of a successful load */
#dgrid-css-TouchScroll-loaded {
	display: none;
}`, "",{"version":3,"sources":["webpack://./target/debug/2P/derived/ui/dgrid/css/TouchScroll.css"],"names":[],"mappings":"AAAA,8CAA8C;;AAE9C;CACC,aAAa,EAAE,qBAAqB;CACpC,gBAAgB,EAAE,oDAAoD;CACtE,kBAAkB;CAClB,mDAAmD;CACnD,YAAY;AACb;AACA;CACC,UAAU;CACV,8CAA8C;CAC9C,2CAA2C;CAC3C,yCAAyC;CACzC,sCAAsC;AACvC;;AAEA;CACC,qCAAqC;CACrC,kCAAkC;CAClC,kBAAkB;;CAElB,6EAA6E;CAC7E,8CAA8C;AAC/C;;AAEA;CACC,SAAS;CACT,UAAU;CACV,WAAW;CACX,WAAW;AACZ;AACA;CACC,QAAQ;CACR,WAAW;CACX,UAAU;CACV,UAAU;AACX;;AAEA;CACC,cAAc,EAAE,uCAAuC;AACxD;;AAEA;CACC,qEAAqE;CACrE,+DAA+D;CAC/D,4DAA4D;CAC5D,0DAA0D;CAC1D,uDAAuD;AACxD;;AAEA,mCAAmC;AACnC;CACC,aAAa;AACd","sourcesContent":["/* styles for scrollbars during touch-scroll */\n\n.touchscroll-x, .touchscroll-y {\n\tdisplay: none; /* overridden below */\n\toverflow: hidden; /* cut off ends of scrollbar during rubber-banding */\n\tposition: absolute;\n\t/* establish base style for scrollbar fade-in/out */\n\topacity: 0.7;\n}\n.touchscroll-fadeout .touchscroll-x, .touchscroll-fadeout .touchscroll-y {\n\topacity: 0;\n\t-webkit-transition: opacity 0.3s ease-out 0.1s;\n\t-moz-transition: opacity 0.3s ease-out 0.1s;\n\t-o-transition: opacity 0.3s ease-out 0.1s;\n\ttransition: opacity 0.3s ease-out 0.1s;\n}\n\n.touchscroll-bar {\n\tbackground-color: rgba(88,88,88,0.97);\n\tborder: 1px solid rgba(88,88,88,1);\n\tborder-radius: 3px;\n\t\n\t/* the borders aren't anti-aliased on Android, so this smooths it out a bit */\n\t-webkit-box-shadow: 0 0 1px rgba(88,88,88,0.4);\n}\n\n.touchscroll-x {\n\tleft: 1px;\n\tright: 3px;\n\tbottom: 1px;\n\theight: 5px;\n}\n.touchscroll-y {\n\ttop: 1px;\n\tbottom: 3px;\n\tright: 1px;\n\twidth: 5px;\n}\n\n.touchscroll-scrollable-x .touchscroll-x, .touchscroll-scrollable-y .touchscroll-y {\n\tdisplay: block; /* display scrollbar when appropriate */\n}\n\n.touchscroll-bar {\n\t/* Establish transition property and timing function for scrollbars */\n\t-webkit-transition: transform cubic-bezier(0.33, 0.66, 0.66, 1);\n\t-moz-transition: transform cubic-bezier(0.33, 0.66, 0.66, 1);\n\t-o-transition: transform cubic-bezier(0.33, 0.66, 0.66, 1);\n\ttransition: transform cubic-bezier(0.33, 0.66, 0.66, 1);\n}\n\n/* indicator of a successful load */\n#dgrid-css-TouchScroll-loaded {\n\tdisplay: none;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
